

export default abstract class ApplicationEntity{
  constructor(public id:string, data:any){}
}